// import dateformat from 'dateformat'
import React, { useContext, useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import Router from 'next/router'
import {
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Typography,
  message,
} from 'antd'
import EmailLogin from 'components/auth/EmailLogin'
import SocialLink from 'components/auth/SocialLink'
import Button from 'components/shared/button'
import authContext from 'contexts/authStatus'
import authToken from 'contexts/authToken'
import {
  ArticleEntity,
  CreateCommentDocument,
  IpoEntity,
} from 'graphql/generated/types'
import { countComments } from 'shared/util'
import RenderComment from './RenderComment'

const { Paragraph, Title } = Typography

const { TextArea } = Input

export default function Comments({
  articleData,
  related,
}: {
  articleData: ArticleEntity | IpoEntity
  related: string
}) {
  const [comments, setComments] = useState(
    articleData.attributes.plugin_comments
  )
  const [currentUserToken, setCurrentUserToken] = useState(null)
  const [modalVisible, setmodalVisible] = useState(false)
  const login: any = useContext(authContext)
  const { setLogin } = login
  const level = 0
  const [form] = Form.useForm()
  useEffect(() => {
    if (localStorage?.authToken) {
      setCurrentUserToken(localStorage.authToken)
    }
  }, [])
  useEffect(() => {
    setComments(articleData.attributes.plugin_comments)
  }, [articleData.attributes.plugin_comments])

  const { jwt } = useContext(authToken)
  const [AddComment] = useMutation(CreateCommentDocument)
  const count = countComments(comments)

  type InputType = {
    content: string
    relation: string
    author: {
      id: string
      name: string
      email: string
      avatar: string
    }
    threadOf?: string
  }
  const submitComment = (content) => {
    let input: InputType = {
      content,
      relation: `${related}:${articleData.id}`,
      author: {
        id: localStorage.getItem('userId'),
        name: localStorage.getItem('userEmail').split('@')[0],
        email: localStorage.getItem('userEmail'),
        avatar: localStorage.getItem('profileUrl'),
      },
    }

    if (localStorage.getItem('parentId')) {
      input = { ...input, threadOf: localStorage.parentId }
    }
    AddComment({
      variables: {
        input: {
          ...input,
        },
      },
      context: {
        headers: {
          Authorization: `Bearer ${jwt ?? currentUserToken}`,
        },
      },
    })
      .then((response) => {
        if (!localStorage.parentId) {
          setComments([response.data.createComment, ...comments])
        }
        // setInputValue(null)
        if (localStorage.parentId) {
          Router.reload()
        }
        localStorage.removeItem('parentId')
        form.resetFields()
        setmodalVisible(false)
      })
      .catch((err) => {
        if (err.status === 403) {
          localStorage.setItem('message', content)
          message.info('Please login again to continue..')
          setmodalVisible(true)
        } else {
          message.error('Sorry Something Went Wrong!')
        }
      })
  }
  const handleAddComment = (values) => {
    if (currentUserToken) {
      // Submiting Comment
      submitComment(values.comment)
    } else {
      localStorage.setItem('message', values.comment)
      setmodalVisible(true)
    }
  }

  const handleCancel = () => {
    setmodalVisible(false)
  }

  // Modal
  const sumbitContentCallback = async () => {
    const tempMessage = localStorage.message
    localStorage.removeItem('message')
    setLogin(true)
    if (tempMessage) {
      await setCurrentUserToken(localStorage.authToken)
      submitComment(tempMessage)
      message.info('Successfully Logged In!')
      message.info('Your message has been added successfully.')
      Router.reload()
    }
  }
  //  managing state for children comments
  const handleCommentUpdate = (updatedComment, id = null) => {
    const updatedComments = id
      ? comments.map((comment) =>
          comment.id === id ? updatedComment : comment
        )
      : [...comments, updatedComment]

    setComments(updatedComments)
  }

  return (
    <Row>
      <Col span={24}>
        <Title level={5} type="secondary" style={{ textAlign: 'center' }}>
          Ask Your Query for FREE, Get quick answers from our FINTRAKK
          community!
        </Title>
        <Title level={5} style={{ color: '#1890ff', marginBottom: 0 }}>
          Discussion ({count})
        </Title>
        <Form form={form} name="basic" onFinish={handleAddComment}>
          <Form.Item
            name="comment"
            rules={[
              {
                required: true,
                message: 'Please type Comment to continue...',
              },
            ]}
          >
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" source="add-comment">
              Submit
            </Button>
          </Form.Item>
        </Form>
        {comments?.length > 0 &&
          comments.map(
            (comment) =>
              ['APPROVED', 'PENDING'].includes(comment.approvalStatus) && (
                <RenderComment
                  parent={comment}
                  key={comment.id}
                  id={articleData.id}
                  item={comment}
                  setmodalVisible={setmodalVisible}
                  setComments={handleCommentUpdate}
                  level={level}
                  status={comment.approvalStatus}
                  style={
                    comment.approvalStatus === 'PENDING'
                      ? { color: '#CAC7CE' }
                      : { color: '' }
                  }
                  related={related}
                />
              )
          )}
      </Col>
      <Modal
        title="Please Login to Discuss"
        open={modalVisible}
        footer={null}
        onCancel={handleCancel}
      >
        <Row className="authPage">
          <Row className="formContainer" style={{ marginTop: '32px' }}>
            <Col span="24">
              <Row className="row">
                <Col span="24">
                  <SocialLink
                  // callbackbeforeRedirect={() => sumbitContentCallback()}
                  />
                  <Divider>or</Divider>
                  <Paragraph>Please enter your details to login.</Paragraph>

                  <EmailLogin
                    callbackbeforeRedirect={() => sumbitContentCallback()}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Row>
      </Modal>
    </Row>
  )
}

// ArticleComments.propTypes = {
//   articleData: PropTypes.shape({
//     id: PropTypes.string.isRequired,

//     article_comments: PropTypes.arrayOf({
//       content: PropTypes.string.isRequired,

//       created_at: PropTypes.string.isRequired,

//       user: PropTypes.shape({
//         username: PropTypes.string.isRequired,
//       }),
//     }).isRequired,
//   }).isRequired,
// }
